<template>
  <div>
    <div v-if="templates === null">
      <i class="fas fa-spin fa-fw fa-sync"></i> Please wait while we fetch the designs...
    </div>
    <p v-else-if="!templates.data"><i class="fas fa-exclamation-triangle"></i> No available designs</p>
    <div v-else class="flex flex-wrap">
      <div v-for="template in templates.data" :key="template.product_id" class="w-full lg:w-1/2 flex mb-3 items-center" :class="{'xxl:w-1/3': templates.data.length > 4}">
        <div @click="showPreview(template.product_id)" class="cursor-pointer">
          <iframe :srcdoc="getHtml(template)" class="bg-white mr-3 pointer-events-none border" style="width: 130px" :style="{height: `${height}px`}"></iframe>
        </div>
        <input type="radio" :id="`template${template.product_id}`" v-model="selectedTemplate" :value="template.product_id">
        <label :for="`template${template.product_id}`">{{ template.productDescription }}</label>
      </div>
    </div>

    <modal v-if="previewTemplateId" @leave="previewTemplateId = null" show-close-btn>
      <p v-if="previewError"><i class="fas fa-exclamation-triangle"></i> Failed to fetch preview</p>
      <loader v-else-if="previewTemplate === null" />
      <div v-else>
        <iframe :srcdoc="getHtml(previewTemplate)" class="bg-white mr-3 pointer-events-none w-full" :style="{height: `${height*5.3}px`}"></iframe>
        <div v-if="previewMaxPages > 1" class="flex justify-center items-center mt-6">
          <i class="fas fa-chevron-left cursor-pointer" v-if="previewTemplatePage > 1" @click="prevPage"></i>
          <span class="mx-2">Page: {{ previewTemplatePage }}/{{ previewMaxPages }}</span>
          <i class="fas fa-chevron-right cursor-pointer" v-if="previewTemplatePage < previewMaxPages" @click="nextPage"></i>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import api from '@/http'
import { map } from 'lodash'
import { mapState } from 'vuex'
export default {
  props: {
    category: {
      type: String,
      required: true
    },
    genre: {
      type: String,
      default: null
    },
    value: {
      required: true
    },
    height: {
      default: 90
    }
  },
  data () {
    return {
      selectedTemplate: this.value,
      templates: null,
      previewTemplateId: null,
      previewTemplatePage: 1,
      previewMaxPages: 1,
      previewTemplate: null,
      previewError: false,
      abortController: null
    }
  },
  computed: {
    ...mapState(['selectedOffice'])
  },
  methods: {
    getTemplates () {
      if (this.abortController) {
        this.abortController.abort()
      }
      this.templates = null

      this.abortController = new AbortController()
      api.get('/marketing-packs/mmn-templates', {
        params: {
          office_id: this.selectedOffice.id,
          category: this.category,
          genre: this.genre
        },
        signal: this.abortController.signal
      }).then((response) => {
        this.templates = response.data

        const ids = map(this.templates.data || [], (t) => t.product_id)
        if (!ids.includes(this.selectedTemplate)) {
          this.selectedTemplate = ids[0]
        }
      })
    },
    getHtml (template) {
      return `<!DOCTYPE HTML><html><head><style>html,body{padding:0;margin:0;overflow:hidden}${template.css}</style></head><body>${template.markup}</body></html>`
    },
    showPreview (id) {
      this.previewTemplateId = id
      this.previewTemplatePage = 1
      this.previewMaxPages = 1
      this.previewTemplate = null
      this.getPreview()
    },
    getPreview () {
      this.previewError = false
      this.previewTemplate = null

      api.get(`/marketing-packs/mmn-templates/${this.previewTemplateId}`, {
        params: {
          office_id: this.selectedOffice.id,
          sorts: this.previewTemplatePage
        }
      }).then((response) => {
        this.previewTemplate = response.data.data[0]
        this.previewMaxPages = this.previewTemplate.maxSort
      }).catch(() => {
        this.previewError = true
      })
    },
    prevPage () {
      this.previewTemplatePage--
      this.getPreview()
    },
    nextPage () {
      this.previewTemplatePage++
      this.getPreview()
    }
  },
  watch: {
    selectedOffice: {
      handler () {
        this.getTemplates()
      },
      immediate: true
    },
    selectedTemplate (val) {
      this.$emit('input', val)
    },
    genre () {
      this.selectedTemplate = null
      this.getTemplates()
    }
  }
}
</script>
